import api from 'service/api'

const trainingPortalAPI = api.create('trainingPortal', false)

const show = async ({ publicToken, portalToken }) =>
  trainingPortalAPI.get(`/invite_courses/${publicToken}`, {
    params: { portal_token: portalToken },
  })

const register = async ({ publicToken, portalToken, name, email, phone }) =>
  trainingPortalAPI.post(`/invite_courses/${publicToken}/register`, {
    portal_token: portalToken,
    name,
    email,
    phone,
  })

const verify = async ({ publicToken, portalToken, name, email, phone, code }) =>
  trainingPortalAPI.post(`/invite_courses/${publicToken}/verify`, {
    portal_token: portalToken,
    name,
    email,
    phone,
    code,
  })

export default { show, register, verify }
